import { Sparkles } from 'lucide-react';

/**
 * "Premium Instructor" badge — shown on instructor cards & profile for
 * users whose backend `is_premium_instructor` flag is true. That flag is
 * derived from `subscription_tiers.is_premium_instructor` in
 * `auth_utils.serialize_user` — true for active Instructor Unlimited
 * subscribers and legacy_lifetime instructors (grandfathered).
 *
 * Visual: subtle white pill with the brand teal→cyan→purple gradient
 * border + gradient text. Matches the rest of the page's gradient
 * language (hero headline, CTAs, login link) instead of the old
 * amber/gold pill that read as out-of-place "AI-default" aesthetic.
 */
export function PremiumInstructorBadge({ size = 'md', className = '', 'data-testid': testId }) {
  const sizes = {
    sm: { pad: 'px-1.5 py-[3px]', text: 'text-[10px]', icon: 'w-2.5 h-2.5', border: 'p-[1px]' },
    md: { pad: 'px-2.5 py-1', text: 'text-[11px]', icon: 'w-3 h-3', border: 'p-[1.5px]' },
    lg: { pad: 'px-3 py-1.5', text: 'text-sm', icon: 'w-3.5 h-3.5', border: 'p-[1.5px]' },
  };
  const s = sizes[size] || sizes.md;
  const gradient = 'linear-gradient(135deg, #56dfb4, #56c6df, #b456df)';
  return (
    <span
      data-testid={testId || 'premium-instructor-badge'}
      title="Premium Instructor — Instructor Unlimited member"
      className={`inline-block rounded-full ${s.border} ${className}`}
      style={{ backgroundImage: gradient }}
    >
      <span
        className={`flex items-center gap-1 rounded-full bg-white font-semibold tracking-wide uppercase ${s.pad} ${s.text}`}
      >
        <Sparkles className={s.icon} style={{ color: '#b456df' }} />
        <span className="bg-clip-text text-transparent" style={{ backgroundImage: gradient }}>
          Premium Instructor
        </span>
      </span>
    </span>
  );
}
